import loggingDevInfo from '@/services/log-dev-info';

export const doesBrowserSupportLocalStorage = (type) => {
	// type equals = localStorage || sessionStorage
	let storage;
	try {
		storage = window[type];
		const x = '__storage_test__';
		storage.setItem(x, x);
		storage.removeItem(x);
		return true;
	} catch (e) {
		loggingDevInfo(`localStorage - ${e}`, 'error');
		return false;
	}
};
